angular.module('tradersyard').directive('focusHandler', [
    '$timeout',
    '$parse',
    function ($timeout, $parse) {
        return {
            link: function ($scope, $element, $attrs) {
                if ($attrs.focusHandler === undefined) return;

                var handler = $attrs.focusHandler;

                function Focus(handle) {
                    if (handle !== false) $element.focus();
                }

                function Blur(handle) {
                    if (handle !== false) $element.blur();
                }

                $parse(handler + '.DoFocus').assign($scope, Focus);
                $parse(handler + '.DoBlur').assign($scope, Blur);
            },
        };
    },
]);
